import { Box, styled } from '@mui/material';

const DateWrapper = styled(Box)`
  width: 240px;
`;

export default DateWrapper;
